// Lightweight wrapper around gtag with runtime safety and env-based configuration.
// Usage:
// - Set REACT_APP_GADS_ID (optional, defaults to 'AW-10862597581')
// - Set REACT_APP_GADS_CONVERSION_LABEL for the specific conversion you want to track
// - Call gtagConversion({ value, currency, transaction_id }) after successful purchase

import { isDev } from "../config";

export type ConversionParams = {
  value?: number;
  currency?: string;
  transaction_id?: string;
  [key: string]: any;
};

export function gtagEvent(action: string, params?: Record<string, any>) {
  if (typeof window === "undefined" || typeof window.gtag !== "function")
    return;
  window.gtag("event", action, params || {});
}

export function gtagConversion(label: string, params: ConversionParams = {}) {
  if (isDev) return;
  if (typeof window === "undefined" || typeof window.gtag !== "function")
    return;

  const payload: Record<string, any> = {
    send_to: `AW-10862597581/${label}`,
    ...params,
  };

  window.gtag("event", "conversion", payload);
}
